const BUTTON_SIZES = ['btn-sm', 'btn-lg'];

const LEGACY_CLASS_MAP = {
  'sm': 'btn-sm',
  'md': '',
  'lg': 'btn-lg',
};

export const ButtonSizePropertyMixin =
{
  props: {
    buttonSize:
        {
          type: [String, null],
          default: null,
          validator: (value) => {
            return [
              '',
              ...BUTTON_SIZES,
              ...Object.keys(LEGACY_CLASS_MAP),
            ].indexOf(value) !== -1;
          },
        },
  },

  computed: {
    buttonSizeClass() {
      if (LEGACY_CLASS_MAP.hasOwnProperty(this.buttonSize)) {
        return LEGACY_CLASS_MAP[this.buttonSize];
      }

      return this.buttonSize;
    },
  },
};
